"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from "react";
import { useLayoutEffect, useRef, useState } from "react";
const COMPACT_PX = 256;
const COMPACT_THRESHOLD_PX = COMPACT_PX * 1.5;
interface CompactDropPreviewProps {
  readonly children: ReactElement;
}
export default function CompactDropPreview(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const [measuredHeight, setMeasuredHeight] = useState(null);
  const measureRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== measuredHeight) {
    t1 = () => {
      if (measuredHeight !== null) {
        return;
      }
      const el = measureRef.current;
      if (!el) {
        return;
      }
      const rect = el.getBoundingClientRect();
      if (rect.height > 0) {
        setMeasuredHeight(rect.height);
      }
    };
    t2 = [measuredHeight];
    $[0] = measuredHeight;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const shouldCompact = measuredHeight === null || measuredHeight > COMPACT_THRESHOLD_PX;
  const showMeasure = measuredHeight === null;
  const heightClassName = !shouldCompact || isExpanded ? "" : "tw-h-64";
  const overflowClassName = isExpanded || !shouldCompact ? "tw-overflow-visible" : "tw-overflow-hidden";
  const rootClassName = `tw-relative tw-w-full tw-min-w-0 tw-max-w-full ${heightClassName} ${overflowClassName}`;
  let t3;
  if ($[3] !== children || $[4] !== showMeasure) {
    t3 = showMeasure ? <div ref={measureRef} className="tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-w-full tw-opacity-0" aria-hidden={true} inert={true}>{children}</div> : null;
    $[3] = children;
    $[4] = showMeasure;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isExpanded || $[7] !== shouldCompact) {
    t4 = !isExpanded && shouldCompact ? <><div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-14 tw-bg-gradient-to-b tw-from-transparent tw-to-iron-950" aria-hidden="true" /><button type="button" className="tw-absolute tw-bottom-2 tw-right-2 tw-z-10 tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-iron-600/40 tw-bg-black/40 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-text-iron-200 tw-backdrop-blur tw-transition-colors hover:tw-border-iron-500/60 hover:tw-bg-black/60" aria-expanded={isExpanded} onClick={() => setIsExpanded(true)}>Show full drop</button></> : null;
    $[6] = isExpanded;
    $[7] = shouldCompact;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== rootClassName || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={rootClassName}>{t3}{children}{t4}</div>;
    $[9] = children;
    $[10] = rootClassName;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}